var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sb_progress-bar_container",style:({ width: (_vm.maxWidth + "px")})},[_c('div',{staticClass:"sb_progress-bar_back"}),_c('div',{staticClass:"sb_progress-bar_front",style:({ width: (_vm.progress + "%")})})])}
var staticRenderFns = []

export { render, staticRenderFns }